import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFIssuesSupportSite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 5C2 3.89543 2.89543 3 4 3H18C19.1046 3 20 3.89543 20 5V17C20 18.1046 19.1046 19 18 19H4C2.89543 19 2 18.1046 2 17V5ZM3.2 7V17C3.2 17.4418 3.55817 17.8 4 17.8H18C18.4418 17.8 18.8 17.4418 18.8 17V7H3.2ZM4.7002 5.15002C4.7002 5.56424 4.36441 5.90002 3.9502 5.90002C3.53598 5.90002 3.2002 5.56424 3.2002 5.15002C3.2002 4.73581 3.53598 4.40002 3.9502 4.40002C4.36441 4.40002 4.7002 4.73581 4.7002 5.15002ZM7.1001 5.15002C7.1001 5.56424 6.76431 5.90002 6.3501 5.90002C5.93588 5.90002 5.6001 5.56424 5.6001 5.15002C5.6001 4.73581 5.93588 4.40002 6.3501 4.40002C6.76431 4.40002 7.1001 4.73581 7.1001 5.15002ZM8.75 5.90002C9.16421 5.90002 9.5 5.56424 9.5 5.15002C9.5 4.73581 9.16421 4.40002 8.75 4.40002C8.33579 4.40002 8 4.73581 8 5.15002C8 5.56424 8.33579 5.90002 8.75 5.90002Z",
			fill: "#00100E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 10.5C10 10.2239 10.2239 10 10.5 10H16.5C16.7761 10 17 10.2239 17 10.5C17 10.7761 16.7761 11 16.5 11H10.5C10.2239 11 10 10.7761 10 10.5Z",
			fill: "#00100E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 13.5C10 13.2239 10.2239 13 10.5 13H15C15.2761 13 15.5 13.2239 15.5 13.5C15.5 13.7761 15.2761 14 15 14H10.5C10.2239 14 10 13.7761 10 13.5Z",
			fill: "#00100E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.7998 9.4C4.7998 8.95817 5.15798 8.6 5.5998 8.6H7.4998C7.94163 8.6 8.2998 8.95817 8.2998 9.4V15.3C8.2998 15.7418 7.94163 16.1 7.4998 16.1H5.5998C5.15798 16.1 4.7998 15.7418 4.7998 15.3V9.4Z",
			fill: "#00100E"
		})
	]
});
export default SvgFIssuesSupportSite;
